import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
      {
        path: '/detailText',
        name: 'detailText',
        component: resolve => require(['@/pages/detail-text'], resolve),
        meta: {
          title: '记忆旅途-文章详情'
        }
      },
      {
      path: '/',
      name: 'index',
      redirect: "/list",
      component: resolve => require(['@/pages/index'], resolve),
      meta: {
        title: '记忆旅途-首页'
      },
      children: [
        {
          path: '/list',
          name: 'list',
          component: resolve => require(['@/pages/list'], resolve),
          meta: {
            title: '记忆旅途-首页'
          }
        },
        {
          path: '/login',
          name: 'login',
          component: resolve => require(['@/pages/login'], resolve),
          meta: {
            title: '记忆旅途-登录'
          }
        },
        {
          path: '/personCenter',
          name: 'personCenter',
          component: resolve => require(['@/pages/person-center'], resolve),
          meta: {
            title: '记忆旅途-个人中心'
          }
        },
        {
          path: '/regist',
          name: 'regist',
          component: resolve => require(['@/pages/regist'], resolve)
        },
        {
          path: '/my-content',
          name: 'my-content',
          component: resolve => require(['@/pages/myContent'], resolve),
          meta: {
            title: '记忆旅途-我的文章'
          }
        },
        {
          path: '/write',
          name: 'write',
          component: resolve => require(['@/pages/write'], resolve),
          meta: {
            title: '记忆旅途-写文章'
          }
        },
        {
          path: '/detail',
          name: 'detail',
          component: resolve => require(['@/pages/detail'], resolve),
          meta: {
            title: '记忆旅途-文章详情'
          }
        },
        {
          path: '/category',
          name: 'category',
          component: resolve => require(['@/pages/category'], resolve),
          meta: {
            title: '记忆旅途-分类管理'
          }
        },
        {
          path: '/reset-pwd',
          name: 'reset-pwd',
          component: resolve => require(['@/pages/reset-pwd'], resolve),
          meta: {
            title: '记忆旅途-重置密码'
          }
        },
        {
          path: '/other-login',
          name: 'other-login',
          component: resolve => require(['@/pages/other-login'], resolve),
          meta: {
            title: '记忆旅途-授权登录'
          }
        },
        {
          path: '/tools/html2word',
          name: 'html2word',
          component: resolve => require(['@/pages/tools/html2word'], resolve),
          meta: {
            title: '记忆旅途-html转word'
          }
        },
        {
          path: '/tools/url2word',
          name: 'url2word',
          component: resolve => require(['@/pages/tools/url2word'], resolve),
          meta: {
            title: '记忆旅途-html转word'
          }
        },
        {
          path: '/tools/index',
          name: 'index',
          component: resolve => require(['@/pages/tools/index'], resolve),
          meta: {
            title: '记忆旅途-在线工具'
          }
        },
        {
          path: '/tools/html2html',
          name: 'html2html',
          component: resolve => require(['@/pages/tools/html2html'], resolve),
          meta: {
            title: '记忆旅途-html转文字'
          }
        },
        {
          path: '/tools/pdf2word',
          name: 'pdf2word',
          component: resolve => require(['@/pages/tools/pdf2word'], resolve),
          meta: {
            title: '记忆旅途-pdf转word'
          }
        },
        {
          path: '/tools/word2pdf',
          name: 'word2pdf',
          component: resolve => require(['@/pages/tools/word2pdf'], resolve),
          meta: {
            title: '记忆旅途-word转pdf'
          }
        },
        {
          path: '/tools/ocr',
          name: 'ocr',
          component: resolve => require(['@/pages/tools/ocr'], resolve),
          meta: {
            title: '记忆旅途-文字识别'
          }
        },
        {
          path: '/tools/time',
          name: 'time',
          component: resolve => require(['@/pages/tools/time'], resolve),
          meta: {
            title: '记忆旅途-时间转换'
          }
        }
      ]
  },
  {
    path: '/admin_index',
    name: 'admin_index',
    component: resolve => require(['@/pages/admin/admin_index'], resolve),
    meta: {
      title: '记忆旅途-后台管理'
    },
    children: [
      {
        path: '/admin_content_list',
        name: 'admin_content_list',
        component: resolve => require(['@/pages/admin/admin_content_list'], resolve)
      },
      {
        path: '/admin_examine',
        name: 'admin_examine',
        component: resolve => require(['@/pages/admin/admin_examine'], resolve)
      }
    ]
  }
]
})



// WEBPACK FOOTER //
// ./src/router/index.js